import React, { useMemo } from 'react';

import clsx from 'clsx';

type SourceMap = Record<string, string>;

export interface ImageData {
  sources: SourceMap;
  img: { src: string };
}

export interface OptimizedImageProps extends React.ComponentPropsWithoutRef<'picture'> {
  imageData: ImageData;
  imgClassName?: string;
  imgStyle?: React.CSSProperties;
  alt: string;
}

export const OptimizedImage = React.forwardRef<HTMLPictureElement, OptimizedImageProps>(
  (props, ref) => {
    const { imageData, alt, className, style, imgClassName, imgStyle, children, ...pictureProps } =
      props;

    if (!imageData || !imageData.sources || !imageData.img) return null;

    const sources = useMemo(() => {
      return Object.entries(imageData.sources).map(([format, src]) => (
        <source key={format} srcSet={src} type={`image/${format}`} />
      ));
    }, [imageData.sources]);

    return (
      <picture
        ref={ref}
        className={clsx('inline-block', className)}
        style={style}
        {...pictureProps}
      >
        {sources}
        <img
          src={imageData.img.src}
          alt={alt}
          loading="lazy"
          className={clsx('h-full w-full object-contain', imgClassName)}
          style={imgStyle}
        />
      </picture>
    );
  },
);
